import React, { useMemo, useState } from 'react';
import ConfirmationDialog from '../../../../../../Dialog/ConfirmationDialog/ConfirmationDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import { translate } from '../../../../../../../utils/translation/translation';
import { useRecoilValue } from 'recoil';
import { translationsState } from '../../../../../../../atoms/translation/translation.atom';
import { colors } from '../../../../../../../styles/colors';
import { roleAccessState } from '../../../../../../../atoms/auth/auth.atom';
import { hasRoleAccess } from '../../../../../../../utils/access/access';
import { HttpMethod } from '../../../../../../../domain/Role';
import MenuItem from '../../MenuItem/MenuItem';

export type DeleteActionAccess = {
  url: string;
  method: HttpMethod;
};

export type DeleteActionProps = {
  title: string;
  description: string;
  successMessage: string;
  apiUrl: string;
  onSuccess?: () => void;
  baseApiUrl?: string;
  label?: string;
  access?: DeleteActionAccess;
};

export const DeleteAction = ({
  title,
  description,
  successMessage,
  apiUrl,
  onSuccess,
  baseApiUrl,
  label,
  access,
}: DeleteActionProps) => {
  const translations = useRecoilValue(translationsState);
  const roleAccessValue = useRecoilValue(roleAccessState);
  const [isOpen, setIsOpen] = useState(false);

  const isDisabled = useMemo(() => {
    if (access) {
      return !hasRoleAccess(roleAccessValue, access.method, access.url);
    }

    if (!baseApiUrl) {
      return false;
    }

    return !hasRoleAccess(
      roleAccessValue,
      HttpMethod.DELETE,
      `${baseApiUrl}/:id`,
    );
  }, [baseApiUrl, access]);

  const handleClick = (e: any) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <MenuItem
        onClick={handleClick}
        style={{ color: colors.inputErrorColor }}
        disabled={isDisabled}
      >
        <DeleteIcon width={20} height={20} />
        {label ?? translate(translations, 'CONFIRMATION_DIALOG.DELETE')}
      </MenuItem>
      <ConfirmationDialog
        title={title}
        apiUrl={apiUrl}
        description={description}
        successMessage={successMessage}
        onSuccess={onSuccess}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default DeleteAction;
